import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'e5core-ui-monitor-sla-inflows',
  template: `
    <e5core-ui-monitor-sla-inflows-highcharts (slaRangeInDays)="slaRangeInDays">
    </e5core-ui-monitor-sla-inflows-highcharts>
  `
})
export class E5coreUiMonitorSlaInflowsComponent implements OnInit {

  @Input() slaRangeInDays = 28; // number
  @Input() startDate: Date; // Drop down menu for start date

  constructor() { }

  ngOnInit() {

  }


}
